<template>
  <div class="q-pa-sm">
    <task-queues
      :options="options"
      @select="onRowDblClick"
    />
  </div>
</template>

<script>
// Vuex
import { mapMutations } from 'vuex'

// Components
import TaskQueues from '../../components/queue/TaskQueues.vue'

export default {
  name: 'BundlingQueues',
  components: {
    TaskQueues
  },
  computed: {
    options () {
      return {
        type: 'bundling',
        title: this.$t('Bundling'),
        service: this.$service.assemblingQueue,
        adapters: ['bundling']
      }
    }
  },
  methods: {
    ...mapMutations([
      'setAssemblingQueue'
    ]),
    onRowDblClick ({ item, toFilters }) {
      this.setAssemblingQueue(item)
      const path = `/workstation/queues/packing/entity/${item.id}${toFilters ? '?start=true' : ''}`
      this.$router.push(path)
    }
  }
}
</script>
